/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M10.605.304l.093.093a1.046 1.046 0 010 1.47L4.943 7.695a1.02 1.02 0 01-1.454 0L.302 4.474a1.046 1.046 0 010-1.47l.093-.094a1.02 1.02 0 011.454 0L4.22 5.308 9.151.314a1.01 1.01 0 011.454-.01z" _fill="#000" fill-rule="evenodd"/>'
  }
})
